var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.13 1.99951C10.4815 2.00452 10.8169 2.14824 11.063 2.39937L13.5954 4.9318C13.8465 5.17789 13.9902 5.51324 13.9953 5.86481V12.6624C13.9953 13.0159 13.8548 13.3549 13.6049 13.6049C13.3549 13.8548 13.0159 13.9953 12.6624 13.9953H3.33237C2.97888 13.9953 2.63986 13.8548 2.3899 13.6049C2.13994 13.3549 1.99951 13.0159 1.99951 12.6624V3.33237C1.99951 2.97888 2.13994 2.63986 2.3899 2.3899C2.63986 2.13994 2.97888 1.99951 3.33237 1.99951H10.13Z",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3293 13.995V9.33C11.3293 9.15326 11.2591 8.98375 11.1341 8.85877C11.0092 8.73379 10.8397 8.66357 10.6629 8.66357H5.33147C5.15472 8.66357 4.98521 8.73379 4.86023 8.85877C4.73525 8.98375 4.66504 9.15326 4.66504 9.33V13.995",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66504 1.99951V4.66523C4.66504 4.84198 4.73525 5.01149 4.86023 5.13647C4.98521 5.26145 5.15472 5.33166 5.33147 5.33166H9.99648",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon26);
export default __webpack_public_path__ + "static/media/icon26.abc4f641f924122e16aa5c6f31798ec0.svg";
export { ForwardRef as ReactComponent };